@if (searching()) {
  @let search = searchState();
  @if (!search || search.loading) {
    <div class="flex justify-center py-6">
      <mat-spinner diameter="28"></mat-spinner>
    </div>
  } @else if (search.error) {
    <div class="flex items-center gap-2">
      <span class="text-error-500">{{ "packageCoverage.message.diagnosesSearchError" | translate }}</span>
      <button
        class="cursor-pointer font-bold text-primary-500 hover:text-primary-600"
        type="button"
        (click)="retrySearch()"
      >
        {{ "packageConfigurator.action.retry" | translate }}
      </button>
    </div>
  } @else if (searchHits().length) {
    <section class="flex min-h-0 flex-col overflow-hidden rounded-[18px] border border-neutral-100 bg-neutral-0 shadow-[0_8px_24px_rgb(0_0_0/0.06)]">
      <div class="max-h-[60vh] min-h-0 overflow-auto text-sm">
        @for (hit of searchHits(); track hit.code) {
          <div class="flex items-start gap-3 border-b border-neutral-100 px-3.5 py-2 hover:bg-primary-50">
            <span class="w-14 shrink-0 font-bold text-neutral-500">{{ hit.code }}</span>
            <span class="text-neutral-400">{{ hit.name }}</span>
          </div>
        }
      </div>
    </section>
  } @else {
    <p class="text-neutral-300">{{ "packageCoverage.message.noDiagnosesSearchHits" | translate }}</p>
  }
} @else if (blocksState()?.loading) {
  <div class="flex justify-center py-6">
    <mat-spinner diameter="28"></mat-spinner>
  </div>
} @else {
  <section class="flex min-h-0 flex-col overflow-hidden rounded-[18px] border border-neutral-100 bg-neutral-0 shadow-[0_8px_24px_rgb(0_0_0/0.06)]">
    <div class="max-h-[60vh] min-h-0 overflow-auto text-sm">
      <insurance-packages-icd10-diagnoses-tree
        [groups]="groups()"
        [names]="allNames()"
        [loadStates]="diagnosisNames()"
        [groupsError]="!!blocksState()?.error"
        (blockOpened)="onBlockOpened($event)"
        (categoryOpened)="onCategoryOpened($event)"
        (retry)="retryNames($event)"
        (retryGroups)="loadBlocks()"
      ></insurance-packages-icd10-diagnoses-tree>
    </div>
  </section>
}
